import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';

import { EDIE_BLOCK_TYPE } from '@cimpress-technology/edie-processors';
import classNames from 'classnames';
import { DropTargetProps } from '../../../models/XBlockProps';

class XCsvMainDropTarget extends Component<DropTargetProps> {

  render () {
    let target = <div className={classNames([
      'xemail-horizontal-drop-target',
      { 'xemail-dragging-can-drop-and-over': this.props.isDragging && this.props.canDrop && this.props.isOver },
      { 'xemail-dragging-can-drop': this.props.isDragging && this.props.canDrop && !this.props.isOver && !this.props.disabled }
    ])}>
      &nbsp;
    </div>;

    return this.props.disabled ? target : this.props.connectDropTarget(target);
  }
}

const columnTarget = {
  drop (props, monitor, _component) {
    props.onDrop({ id: 'main' }, { type: monitor.getItemType(), metadata: monitor.getItem().resourceTypeMetadata, id: monitor.getItem().itemId  }, props.position);
  }
};

function collect (connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({ shallow: true }),
    canDrop: monitor.canDrop(),
    isDragging: [EDIE_BLOCK_TYPE.LOOP].indexOf(monitor.getItemType()) !== -1
  };
}

export default DropTarget([EDIE_BLOCK_TYPE.LOOP], columnTarget, collect)(XCsvMainDropTarget);
